import { FC, Fragment, useContext } from "react";

import { AuthContext } from "src/context/authContext";
import GuestHeader from "./guestHeader";
import AuthHeader from "./authHeader";


const Header: FC = (): JSX.Element => {
  const { isUserAuthorized } = useContext(AuthContext);

  return (
    <Fragment>
      {isUserAuthorized ? (
        <AuthHeader />
      ) : (
        <GuestHeader />
      )}
    </Fragment>
  );
};

export default Header;
